import axios from "axios";
import { useEffect, useState } from "react";
import { createGlobalStyle } from "styled-components";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { apiCall_domain } from "../api";
import Header from "../header";
import Spinner from "../Spinner/Spinner";
import * as React from "react";
import Box from "@mui/material/Box";
import useSimpleReactValidator from "../../Hooks/useSimpleReactValidator";
import PulseLoader from "react-spinners/PulseLoader";

const AddCar = (props) => {
  const [state, setState] = useState({
    loading: true,
    cars: [],
    submitLoading: false,
  });
  const [name, setName] = useState();
  const [brands, setBrands] = useState("");
  const [models, setModels] = useState("");
  const [types, setType] = useState("");
  const [validator, forceUpdate] = useSimpleReactValidator({
    className: "danger addCarReq",
    messages: { required: "این فیلد نباید خالی باشد" },
    autoForceUpdate: true,
  });

  useEffect(() => {
    const headers = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };
    axios
      .get(`${apiCall_domain}/customer/car-types`, { headers: headers })
      .then((res) => setState({ loading: false, cars: res.data.data }));
  }, []);
  const handleCarName = (e) => {
    setName(e.target.value);
  };
  const handleCarBrand = (e) => {
    setBrands(e.target.value);
    setModels("");
    setType("");
  };
  const handleCarModel = (e) => {
    setModels(e.target.value);
    setType("");
  };
  const handleCarType = (e) => {
    setType(e.target.value);
  };
  const submit = () => {
    validator.showMessages();
    forceUpdate(true);
    if (validator.allValid()) {
      setState({ ...state, submitLoading: true });
      const Data = {
        car_id: models.id,
        name: name,
        type_id: types.id,
      };

      const headers = {
        Authorization: localStorage.getItem("Api_key"),
        "content-type": "application/json",
      };
      axios
        .post(`${apiCall_domain}/customer/user/cars`, Data, {
          headers: headers,
        })
        .then((res) =>
          props.history.push({
            pathname: "/profile/MyCars",
          }),
        );
    }
  };
  const GlobalStyles = createGlobalStyle`body{
         background: #FAFAFA  !important;
     }`;

  return (
    <>
      {state.loading ? (
        <Spinner />
      ) : (
        <>
          <GlobalStyles />
          <Header
            showSearchBar={true}
            title="افزودن خودرو جدید"
            backUrl="/profile/MyCars"
          />
          <div className="addNewCar">
            <div className="inputBox">
              <div className="inputSection">
                <input
                  type="text"
                  name="name"
                  value={name}
                  placeholder="نام خودرو"
                  onChange={handleCarName}
                />
                {validator.message("name", name, "required")}
              </div>
              <div className="inputSection">
                <Box sx={{ minWidth: 120 }}>
                  <FormControl>
                    <Select
                      displayEmpty
                      name="brands"
                      label="برند خودرو"
                      value={brands}
                      inputProps={{ "aria-label": "Without label" }}
                      onChange={handleCarBrand}
                    >
                      <MenuItem disabled value="" className="addCarPlaceHolder">
                        برند خودرو
                      </MenuItem>
                      {state?.cars.map((car, index) => (
                        <MenuItem key={index} value={car}>
                          {car.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
                {validator.message("brands", brands, "required")}
              </div>
              <div className="inputSection">
                <Box sx={{ minWidth: 120 }}>
                  <FormControl>
                    <Select
                      displayEmpty
                      disabled={!brands}
                      name="models"
                      value={models}
                      inputProps={{ "aria-label": "Without label" }}
                      onChange={handleCarModel}
                    >
                      <MenuItem disabled value="" className="addCarPlaceHolder">
                        مدل خودرو
                      </MenuItem>

                      {brands
                        ? brands.cars.map((brand, index) => (
                            <MenuItem key={index} value={brand}>
                              {brand.name}
                            </MenuItem>
                          ))
                        : null}
                    </Select>
                  </FormControl>
                </Box>
                {validator.message("models", models, "required")}
              </div>

              <div className="inputSection">
                <Box sx={{ minWidth: 120 }}>
                  <FormControl>
                    <Select
                      displayEmpty
                      disabled={!models}
                      name="types"
                      value={types}
                      inputProps={{ "aria-label": "Without label" }}
                      onChange={handleCarType}
                    >
                      <MenuItem disabled value="" className="addCarPlaceHolder">
                        تیپ
                      </MenuItem>

                      {models
                        ? models.types.map((year, index) => (
                            <MenuItem key={index} value={year}>
                              {year.name}
                            </MenuItem>
                          ))
                        : null}
                    </Select>
                  </FormControl>
                </Box>
                {validator.message("types", types, "required")}
              </div>
            </div>
            <div className="btnSection">
              <button className="addCarSubmit" onClick={submit}>
                {state.submitLoading ? (
                  <PulseLoader size={12} color="#fff" loading={true} />
                ) : (
                  "افزودن"
                )}
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default AddCar;
